import CoreFooterModule from './module';

export { CoreFooterModule };
